import { Component } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoginComponent } from '../app/login/login.component';
import * as firebase from 'firebase/app';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(public auth: AngularFireAuth, public router: Router) {
    this.auth.authState.subscribe(res => {
      if (res && res.uid) {

      } else {
        // FORWARD TO LOGIN SCREEN
        router.navigateByUrl('/login');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts